import React, { useState } from 'react';
import NavBar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import './Inspiration.css';
import InfoBar from '../../components/InfoBar/InfoBar';

export default function Inspiration() {
  const [activeFilter, setActiveFilter] = useState('All');

  const categories = [
    'All',
    'Flowers',
    'Care',
    'Gifts',
    'General',
    'Spring',
    'Summer',
    'Valentine',
    'Christmas'
  ];

  const articles = [
    {
      id: 1,
      title: 'Flowers in your interior',
      description: '5 Tips for incorporating flowers into your interior – with the charm of Tulipink. Flowers give every room a fresh and vibrant atmosphere...',
      category: 'Flowers',
      image: 'https://images.unsplash.com/photo-1485955900006-10f4d324d411?w=800&h=600&fit=crop',
      date: 'March 15, 2024'
    },
    {
      id: 2,
      title: 'Why a clean vase is essential',
      description: 'Why a clean vase is the secret to a longer-lasting bouquet. When you receive a beautiful bouquet, you naturally want to enjoy it as long as possible...',
      category: 'Care',
      image: 'https://images.unsplash.com/photo-1455659817273-f96807779a8a?w=800&h=600&fit=crop',
      date: 'March 12, 2024'
    },
    {
      id: 3,
      title: 'Cut flowers that won\'t give you hay fever',
      description: 'The ideal choice for allergy sufferers. Would you like the beauty of fresh flowers in your home without the inconvenience of hay fever?',
      category: 'General',
      image: 'https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=800&h=600&fit=crop',
      date: 'March 10, 2024'
    },
    {
      id: 4,
      title: 'Flowers of the season – Spring',
      description: 'What\'s blooming beautifully now? Spring is in full swing and that means an explosion of colors and scents in the flower world...',
      category: 'Spring',
      image: 'https://images.unsplash.com/photo-1462275646964-a0e3386b89fa?w=800&h=600&fit=crop',
      date: 'March 8, 2024'
    },
    {
      id: 5,
      title: 'Meaning of flowers for Mother\'s Day',
      description: 'Say it with flowers! Mother\'s Day is just around the corner. Discover the perfect flowers and their beautiful meanings...',
      category: 'Flowers',
      image: 'https://images.unsplash.com/photo-1582794543139-8ac9cb0f7b11?w=800&h=600&fit=crop',
      date: 'March 5, 2024'
    },
    {
      id: 6,
      title: 'The perfect gift for Mother\'s Day',
      description: 'Mother\'s Day is the moment to show appreciation and love to the woman who is always there for you. Every mother deserves something special...',
      category: 'Gifts',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
      date: 'March 3, 2024'
    },
    {
      id: 7,
      title: 'Choosing funeral flowers',
      description: 'A Complete Guide to a Personal Farewell. Flowers play an important role in saying goodbye to a loved one...',
      category: 'General',
      image: 'https://images.unsplash.com/photo-1496062031456-07b8f162a322?w=800&h=600&fit=crop',
      date: 'March 1, 2024'
    },
    {
      id: 8,
      title: 'Flowers for a new home',
      description: 'The Perfect Housewarming Gift. A new home means a new beginning. Whether it\'s your own home or someone else\'s...',
      category: 'Gifts',
      image: 'https://images.unsplash.com/photo-1513519245088-0e12902e35ca?w=800&h=600&fit=crop',
      date: 'February 28, 2024'
    },
    {
      id: 9,
      title: 'Christmas arrangement in the house',
      description: 'The magic of a Christmas arrangement or Christmas bouquet in your home: A festive atmosphere during the holidays...',
      category: 'Christmas',
      image: 'https://images.unsplash.com/photo-1512916206820-91ef0c14be37?w=800&h=600&fit=crop',
      date: 'December 20, 2023'
    },
    {
      id: 10,
      title: 'Top 5 Cut Flowers for Spring',
      description: 'Spring, the season of renewal. Nature awakens and flowers bloom. Here are five typical cut flowers for spring...',
      category: 'Spring',
      image: 'https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=800&h=600&fit=crop',
      date: 'February 25, 2024'
    },
    {
      id: 11,
      title: 'Affordable Valentine\'s Day Gifts',
      description: 'The Top 5 Affordable Valentine\'s Day Gifts That Guarantee a Smile! Valentine\'s Day is just around the corner...',
      category: 'Valentine',
      image: 'https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=800&h=600&fit=crop',
      date: 'February 10, 2024'
    },
    {
      id: 12,
      title: 'Why do we give flowers on Valentine\'s Day',
      description: 'There is a hint of love in the air. It\'s almost that time again, February 14th is Valentine\'s Day...',
      category: 'Valentine',
      image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=800&h=600&fit=crop',
      date: 'February 5, 2024'
    },
    {
      id: 13,
      title: 'Flowers in your home',
      description: '7 reasons why you want flowers in your home. Flowers not only bring beauty and color to your living space...',
      category: 'Flowers',
      image: 'https://images.unsplash.com/photo-1487070183336-b863922373d4?w=800&h=600&fit=crop',
      date: 'January 28, 2024'
    },
    {
      id: 14,
      title: 'Summer flower care tips',
      description: 'Keep your summer bouquets fresh longer with these essential care tips for the warmer months...',
      category: 'Summer',
      image: 'https://images.unsplash.com/photo-1464047736614-af63643285bf?w=800&h=600&fit=crop',
      date: 'July 15, 2023'
    },
    {
      id: 15,
      title: 'Creating stunning summer arrangements',
      description: 'Discover the vibrant colors and textures perfect for summer flower arrangements that brighten any space...',
      category: 'Summer',
      image: 'https://images.unsplash.com/photo-1508610048659-a06b669e3321?w=800&h=600&fit=crop',
      date: 'June 20, 2023'
    }
  ];

  const filteredArticles = activeFilter === 'All' 
    ? articles 
    : articles.filter(article => article.category === activeFilter);

  return (
    <>
    <InfoBar/>
      <NavBar />
      <div className="inspiration-page">
        {/* Hero Section */}
        <section className="inspiration-hero">
          <div className="inspiration-hero-content">
            <h1 className="inspiration-hero-title">Get Inspired</h1>
            <p className="inspiration-hero-subtitle">
              Discover the latest trends, tips, and beautiful flower arrangements
            </p>
          </div>
        </section>

        {/* Main Content */}
        <section className="inspiration-content">
          <div className="inspiration-container">
            {/* Category Filter */}
            <div className="inspiration-filter-section">
              <h2 className="inspiration-filter-title">Discover the latest trends</h2>
              <div className="inspiration-filter-buttons">
                {categories.map((category) => (
                  <button
                    key={category}
                    className={`inspiration-filter-btn ${activeFilter === category ? 'inspiration-filter-active' : ''}`}
                    onClick={() => setActiveFilter(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Articles Grid */}
            <div className="inspiration-articles-grid">
              {filteredArticles.map((article) => (
                <article key={article.id} className="inspiration-article-card">
                  <div className="inspiration-article-image">
                    <img src={article.image} alt={article.title} />
                    <span className="inspiration-article-category">{article.category}</span>
                  </div>
                  <div className="inspiration-article-content">
                    <h3 className="inspiration-article-title">{article.title}</h3>
                    <p className="inspiration-article-description">{article.description}</p>
                    <div className="inspiration-article-footer">
                      <span className="inspiration-article-date">{article.date}</span>
                      <button className="inspiration-read-more">
                        Read more
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M5 12h14"/>
                          <path d="M12 5l7 7-7 7"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {/* Newsletter Section */}
            <div className="inspiration-newsletter">
              <div className="inspiration-newsletter-content">
                <h2 className="inspiration-newsletter-title">
                  Receive the latest trends, tips and tricks directly in your mailbox
                </h2>
                <p className="inspiration-newsletter-description">
                  Have we inspired you, and would you like to continue to be so? Then sign up for the newsletter. 
                  You will receive great inspiration, discounts or tips about once a month.
                </p>
                <form className="inspiration-newsletter-form">
                  <input 
                    type="email" 
                    placeholder="Your email address" 
                    className="inspiration-newsletter-input"
                  />
                  <button type="submit" className="inspiration-newsletter-btn">
                    Sign up
                  </button>
                </form>
              </div>
            </div>

            {/* Info Section */}
            <div className="inspiration-info-section">
              <div className="inspiration-info-card">
                <h3 className="inspiration-info-title">Inspiration</h3>
                <p className="inspiration-info-text">
                  Blogs about flowers are a source of inspiration and information for anyone interested 
                  in the world of flora. Whether you are looking for new ideas for your interior, or just 
                  want to enjoy the beautiful colors and scents, these blogs offer something for everyone.
                </p>
              </div>
              <div className="inspiration-info-card">
                <h3 className="inspiration-info-title">Knowledge</h3>
                <p className="inspiration-info-text">
                  They offer insight into the meaning of different types of flowers, so that you can enjoy 
                  their beauty even more consciously. For example, you know that red roses symbolize love 
                  and passion, and that white lilies are often associated with purity and hope.
                </p>
              </div>
              <div className="inspiration-info-card">
                <h3 className="inspiration-info-title">Ideas</h3>
                <p className="inspiration-info-text">
                  These blogs also share beautiful decoration ideas for special occasions such as Christmas, 
                  Valentine's Day and Easter. They give tips for making flower arrangements with the most 
                  beautiful flowers of the season.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
